/**
 * Restricts a number to the inclusive range [min, max]. Throws on NaN/Infinity
 * rather than silently returning NaN (Math.min/max would otherwise propagate it).
 */
function clamp(value: number, min: number, max: number): number {
    if (!Number.isFinite(value)) {
        throw new RangeError(`clamp: value must be finite, got ${value}`);
    }

    return Math.min(Math.max(value, min), max);
}

export { clamp };
